module.exports = __webpack_public_path__ + "img/BIT_white31.22d60540.jpg";